export default "__VITE_ASSET__DOGUewWT__"